import { FETCH_CONFIGURATION, FETCH_CONFIGURATION_SUCCESS, FETCH_CONFIGURATION_FAILURE } from './types'

export const fetchConfiguration = (accessToken) => ({
  type: FETCH_CONFIGURATION,
  payload: { accessToken },
})

export const fetchConfigurationSuccess = (data) => ({
  type: FETCH_CONFIGURATION_SUCCESS,
  payload: data,
})

export const fetchConfigurationFailure = (error) => ({
  type: FETCH_CONFIGURATION_FAILURE,
  payload: error,
})
